export const DELETE = 'DELETE'
export const GET = 'GET'
export const PUT = 'PUT'
export const POST = 'POST'

export const STATUS_SUCCESS = 'success'
export const STATUS_SUCCESS_CODE = 200

export const API_BASE_PATH = '/api'
